import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 mt-16">
      <div className="max-w-6xl mx-auto px-4 lg:px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-5">
          {/* About Section */}
          <div className="md:col-span-1 lg:col-span-1 mb-8 md:mb-0">
            <h3 className="text-xl font-bold mb-4">About Us</h3>
            <p className="text-gray-400 text-sm md:text-base">
              Your trusted partner in seamless transportation services, providing reliable and comfortable rides across the city.
            </p>
          </div>

          {/* Customer Service */}
          <div className="mb-8 md:mb-0">
            <h3 className="text-xl font-bold mb-4">Customer Service</h3>
            <ul className="space-y-3 text-gray-400">
              <li>
                <Link to="/contactus" className="hover:text-blue-400 text-sm md:text-base transition-colors">
                  Contact Us
                </Link>
              </li>
              {/* <li>
                <Link to="/" className="hover:text-blue-400 text-sm md:text-base transition-colors">
                  Booking Policy
                </Link>
              </li> */}
              <li>
                <Link to="/faq" className="hover:text-blue-400 text-sm md:text-base transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Follow Us */}
          <div className="mb-8 md:mb-0">
            <h3 className="text-xl font-bold mb-4">Follow Us</h3>
            <div className="flex space-x-3 md:space-x-3 lg:space-x-5 justify-start md:justify-start">
              <a href="https://wa.me/8806003303" className="hover:text-green-400 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
              </a>
              <a href="https://www.facebook.com/share/1VwM93oXJf/" className="hover:text-blue-400 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/travelwithzab?utm_source=qr&igsh=MXNkcXNvbjZyN3poMA==" className="hover:text-red-400 transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Customer Service */}
          <div className="mb-4 md:mb-0">
            <h3 className="text-xl font-bold mb-4">Customer Service</h3>
            <ul className="space-y-3 text-gray-400">
              <li>
                <a href="tel:+918806003303" className="hover:text-blue-400 text-sm md:text-base transition-colors">
                  📞 +91 8806003303
                </a>
              </li>
              <li>
                <a href="tel:+917666313579" className="hover:text-blue-400 text-sm md:text-base transition-colors">
                  📞 +91 7666313579
                </a>
              </li>
              <li>
                <a href="tel:+918329067113" className="hover:text-blue-400 text-sm md:text-base transition-colors">
                  📞 +91 8329067113
                </a>
              </li>
            </ul>
          </div>

          {/* Google Map Integration */}
          <div className="md:col-span-2 lg:col-span-1">
            <h3 className="text-xl font-bold mb-4">Find Us</h3>
            <div className="relative h-60 md:h-70 rounded-lg overflow-hidden shadow-lg border-2 border-gray-700">
              <iframe
                title="Company Location"
                className="absolute w-full h-full"
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3783.059791748383!2d73.86372507519184!3d18.52619998256844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDMxJzM0LjMiTiA3M8KwNTEnNTguNyJF!5e0!3m2!1sen!2sin!4v1739853534904!5m2!1sen!2sin"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p className="text-sm md:text-base">
            &copy; {new Date().getFullYear()} Zab tours and travels. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;